import * as R from "remeda";
import { BsonDocument, AppriseNotificationSettingsData, AppriseNotificationType, AppriseNotificationFormat } from "@/API";
import { TextInput, Anchor, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { forwardRef, useEffect, useImperativeHandle } from "react";

export const AppriseNotificationSettingsDataEdit = forwardRef((props: { value: BsonDocument, onChange: (value: BsonDocument) => void }, ref) => {
    const form = useForm<AppriseNotificationSettingsData>({
        initialValues: props.value,
        validate: {
            urls: (value) => (!value ? 'Urls 不得為空' : null),
        },
        onValuesChange: values => props.onChange(values as unknown as BsonDocument)
    });

    useImperativeHandle(ref, () => ({
        validate: () => form.validate()
    }));

    useEffect(() => {
        if (!R.isDeepEqual(form.values, props.value)) {
            form.setValues(props.value as AppriseNotificationSettingsData);
        }
    }, [props.value]);

    return <>
        <div>
            <TextInput
                label="通知目標 (Urls)"
                description={<>請參考 <Anchor href="https://appriseit.com/services/" target="_blank" size="xs">Apprise 支援列表與 URL 格式文件</Anchor> 填寫多個目標以逗號分隔，例如：tgram://bottoken/ChatID/</>}
                {...form.getInputProps('urls')}
            />
            <TextInput
                label="標題 (Title)"
                description="非必填"
                {...form.getInputProps('title')}
            />
            <Select
                label="訊息類型 (Type)"
                data={Object.values(AppriseNotificationType).map(v => ({ value: v, label: v }))}
                {...form.getInputProps('type')}
            />
            <Select
                label="訊息格式 (Format)"
                data={Object.values(AppriseNotificationFormat).map(v => ({ value: v, label: v }))}
                {...form.getInputProps('format')}
            />
        </div>
    </>

});